import React from "react";
import PropTypes from "prop-types";

class ProductMask extends React.Component {
  render() {
    let mask = null;
    let src = null;
    let classNames = "";

    if (this.props.layer.use_product_mask) {
      src = this.props.layer.product_mask;
    }

    if (src) {
      mask = (
        <div className="product-mask">
          <img
            src={src}
            className={`product-mask__mask-image ${classNames}`}
            alt=""
          />
        </div>
      );
    }
    return mask;
  }
}

ProductMask.propTypes = {
  layer: PropTypes.object,
};

export default ProductMask;
